import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Input, Table } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const OrderReturn = () => {
  const crumbList = [
    { tittle: '외부 api 송출 내역', url: '' },
    { tittle: '외부 api 송출 내역 조회', url: '' }
  ];

  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Return Order Status',
      dataIndex: 'returnStatus'
    },
    {
      title: 'Warehouse Return Status',
      dataIndex: 'warehouseReturnStatus'
    },
    {
      title: 'Reason for Return',
      dataIndex: 'returnReason'
    },
    {
      title: 'Type of Return',
      dataIndex: 'returnType'
    },
    {
      title: 'Process Type',
      dataIndex: 'processType'
    },
    {
      title: 'Return Quantity',
      dataIndex: 'quantity'
    },
    {
      title: 'Return to Seller Flag',
      dataIndex: 'returnToSeller',
      render: (value: boolean) => (value ? 'true' : 'false')
    },
    {
      title: 'Recipient Name',
      dataIndex: 'recipientName'
    },
    {
      title: 'Recipient Phone Number',
      dataIndex: 'recipientPhone'
    },
    {
      title: 'Return Address',
      dataIndex: 'returnAddress'
    },
    {
      title: 'City',
      dataIndex: 'city'
    },
    {
      title: 'State/Province',
      dataIndex: 'state'
    },
    {
      title: 'Country',
      dataIndex: 'country'
    },
    {
      title: 'Postal Code',
      dataIndex: 'postalCode'
    },
    {
      title: 'Detailed Return Address Line 1',
      dataIndex: 'detailReturnAddress'
    },
    {
      title: 'Detailed Return Address Line 2',
      dataIndex: 'detailReturnAddress2'
    },
    {
      title: 'Return Comment',
      dataIndex: 'comment'
    },
    {
      title: 'Courier Service Provider',
      dataIndex: 'courier'
    },
    {
      title: 'Tracking Number',
      dataIndex: 'trackingNumber'
    },
    {
      title: 'Warehouse Update Timestamp',
      dataIndex: 'warehouseUpdateDate'
    }
  ];

  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const [token, setToken] = useState('');
  const fetchData = async (page: number) => {
    const res = await axios.get(
      `https://public-api.buskfulfillment.com/api/v1//warehouse/orders/return?page=${page}`,
      {
        headers: {
          'X-Busk-Api-Token': token
        }
      }
    );
    console.log(res.data);
    setTotalPage(res.data.lastPage * 10);
    setData(res.data.data);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={crumbList} />
      <div className="busk-container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: 20,
            marginBottom: 20
          }}
        >
          <Input
            placeholder="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button onClick={() => fetchData(0)}>Fetch</Button>
        </div>
        <Table
          pagination={{
            total: totalPage,
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, limit) => {
              fetchData(page - 1);
              setCurrentPage(page);
            }
          }}
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={data}
        />
      </div>
    </div>
  );
};

export default OrderReturn;
